document.addEventListener('DOMContentLoaded', () => {
  const currencySymbolMap = {
    USD: 'US$',
    EUR: '€',
    CHF: '', // Empty because we show text for CHF instead
  };

  const switcher = document.querySelector('.currency-switcher');
  const picker = document.querySelector('#currency-picker');
  const pickerItems = picker.querySelectorAll('.dropdown-item');
  const pickerFilter = picker.querySelector('input[type="search"]');
  const flag = switcher.querySelector('.flag');
  const name = switcher.querySelector('.country-name');
  const currLabels = document.querySelectorAll('.currency-text');
  const currSymbols = document.querySelectorAll('.currency-symbol');
  const hash = document.location.hash;

  const getCurrencyValueFromHash = (hash) => {
    for (const country of pickerItems) {
      if (country.getAttribute('href') === hash) {
        return country.dataset.currency || 'USD';
      }
    }
    return 'USD';
  };

  const getCurrencySymbolFromValue = (currency) => currencySymbolMap[currency] || 'US$';

  const modifyCurrencyLabels = (labels, value) => {
    labels.forEach((el) => {
      el.textContent = value;
    });
  };

  /**
   * Logic: If currency is CHF (Switzerland/Liechtenstein),
   * show the text label and hide the symbol.
   * Otherwise, show the symbol and hide the text label.
   */
  const updateDisplayMode = (currency) => {
    const isCHF = currency === 'CHF';
    currLabels.forEach((el) => (el.style.display = isCHF ? 'inline' : 'none'));
    currSymbols.forEach((el) => (el.style.display = isCHF ? 'none' : 'inline'));
  };

  const modifyFlagAndName = (el) => {
    let code;
    if (!el) {
      const currentHash = window.location.hash || '#US';
      el =
        document.querySelector(
          `#currency-picker .dropdown-item[href*="${currentHash}"]`,
        ) || document.querySelector('#currency-picker .dropdown-item[href*="#US"]');
    }

    code = el.getAttribute('href').replace('#', '');
    flag.src = `/assets/img/icons/flags/flag-${code}.svg`;
    name.textContent = el.textContent;
  };

  /**
   * Helper to run the full UI update sequence
   */
  const applyCurrencyUpdate = (targetHash) => {
    const currencyValue = getCurrencyValueFromHash(targetHash);
    const symbolValue = getCurrencySymbolFromValue(currencyValue);

    // Find the element associated with this hash
    const targetEl = Array.from(pickerItems).find(
      (item) => item.getAttribute('href') === targetHash,
    );

    modifyCurrencyLabels(currLabels, currencyValue);
    modifyCurrencyLabels(currSymbols, symbolValue);
    modifyFlagAndName(targetEl);
    updateDisplayMode(currencyValue);
  };

  const filterDropdownItems = (e) => {
    let val = e.target.value;
    pickerItems.forEach((item) => {
      item.classList.toggle(
        'hide',
        !item.textContent.toUpperCase().includes(val.toUpperCase()),
      );
    });
  };

  const toggleSwitcher = (event) => {
    if (event.target.id !== 'dropdown-filter') {
      switcher.classList.toggle('show');
    }
  };

  // Event Listeners
  switcher.addEventListener('click', toggleSwitcher);

  const overlay = document.querySelector('.background-overlay');
  if (overlay) overlay.addEventListener('click', toggleSwitcher);

  pickerFilter.addEventListener('input', filterDropdownItems);

  pickerItems.forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      applyCurrencyUpdate(el.getAttribute('href'));
    });
  });

  // --- Initialization Logic ---
  if (hash) {
    // 1. If hash exists, use it
    applyCurrencyUpdate(hash);
  } else {
    // 2. Otherwise, fetch Geo-Location
    fetch('https://cake.com/geo')
      .then((response) => {
        if (!response.ok) throw new Error();
        return response.text();
      })
      .then((data) => {
        const detectedCode = data ? data.trim() : 'US';
        applyCurrencyUpdate(`#${detectedCode}`);
      })
      .catch(() => {
        // 3. Fallback to US if fetch fails
        applyCurrencyUpdate('#US');
      });
  }
});
